import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';

import {
  CampaignControllerDtoAppSearchRequest,
  CampaignControllerDtoCampaignDetailRequest,
  CampaignControllerDtoCampaignLockStateRequest,
  CampaignControllerDtoCampaignRemoveRequest,
  CampaignControllerDtoCampaignSortRequest,
  CampaignControllerDtoCampaignTerminateRequest,
  CampaignControllerDtoCampaignUpdateRequest,
  // CampaignControllerDtoSpecialGameDepositRequest,
  PerplayCampaignApi,
} from '../../models/src';
import {
  CAMPAIGN_CHECK_PACKAGENAME,
  CAMPAIGN_SORT_UPDATE,
  RECOMMENDED_GAME_CREATE,
  RECOMMENDED_GAME_DETAIL_REQUEST,
  RECOMMENDED_GAME_LIST_REQUEST,
  RECOMMENDED_GAME_LOCK_STATE_UPDATE,
  RECOMMENDED_GAME_REMOVE,
  RECOMMENDED_GAME_TERMINATE, RECOMMENDED_GAME_UPDATE_REQUEST,
  SPECIAL_GAME_CREATE,
  // SPECIAL_GAME_DEPOSIT_REQUEST,
  SPECIAL_GAME_DETAIL_REQUEST,
  SPECIAL_GAME_LIST_REQUEST,
  SPECIAL_GAME_LOCK_STATE_UPDATE,
  SPECIAL_GAME_REMOVE,
  SPECIAL_GAME_TERMINATE, SPECIAL_GAME_UPDATE_REQUEST,
} from '../../constants/app/campaignConstants';
import {
  setCampaignResponse,
  setRecommendedGameDetail,
  setSpecialGameDetail,
} from '../../actions/app/campaignActions';
import BaseResponse from '../../models/src/model/BaseResponse';
import CampaignControllerDtoCampaignListRequest from '../../models/src/model/CampaignControllerDtoCampaignListRequest';
import CampaignControllerDtoCampaignListResponse from '../../models/src/model/CampaignControllerDtoCampaignListResponse';
import CampaignControllerDtoCampaignDetailResponse from '../../models/src/model/CampaignControllerDtoCampaignDetailResponse';
import CampaignControllerDtoAppSearchResponse from '../../models/src/model/CampaignControllerDtoAppSearchResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PerplayCampaignApi(config.API_CLIENT);

function* recommendedGameListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoCampaignListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.status = payload.status;
    requestData.includePendingCampaigns = payload.includePendingCampaigns;
    requestData.searchString = payload.searchString || "";
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignRecommendedGameListPost({ campaignControllerDtoCampaignListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoCampaignListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* recommendedGameDetailRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    yield put(setRecommendedGameDetail(null));

    const requestData = new CampaignControllerDtoCampaignDetailRequest();
    requestData.campaignNo = payload.campaignNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignRecommendedGameDetailPost({ campaignControllerDtoCampaignDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoCampaignDetailResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}
function* recommendedGameRemoveRequestSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoCampaignRemoveRequest(payload.campaignNo);
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignRecommendedGameRemovePost({ campaignControllerDtoCampaignRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* recommendedGameCreateRequestSaga(payload) {
  try {
    const result = yield api.apiPerplayCampaignRecommendedGameCreatePost(
      payload && payload.campaignTitle,
      payload && payload.startAt,
      payload && payload.endAt,
      payload && payload.appNo,
      payload && payload.campaignDesc,
      payload && payload.region,
      payload.needType === 1 || payload.needType === 10 ? payload.needMinNftGrade : 0,
      payload.needType === 1 || payload.needType === 10 ? payload.needMinNftLevel : 0,
      payload.needType === 1 || payload.needType === 10 ? payload.needNftType : 0,
      payload && payload.needType,
      payload && payload,
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw Error(`ERROR: ${data.resultCode}`);
    }
    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    // api 호출 시 에러가 발생하면 이리로 온다.
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* recommendedGameLockStateUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    yield put(setCampaignResponse(null));
    const requestData = new CampaignControllerDtoCampaignLockStateRequest();
    requestData.campaignNo = payload.campaignNo;
    requestData.isLock = payload.isLock;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignRecommendedGameLockStatePost({ campaignControllerDtoCampaignLockStateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode === 200) {
      yield put(setCampaignResponse(data.resultCode));
    }

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* recommendedGameTerminateRequestSaga(payload) {
  try {
    yield put(setCampaignResponse(null));
    const requestData = new CampaignControllerDtoCampaignTerminateRequest(payload.campaignNo);
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignRecommendedGameTerminatePost({ campaignControllerDtoCampaignTerminateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);

    if (data.resultCode !== 200) {
      throw Error(`ERROR: ${data.resultCode}`);
    }
    yield put(setCampaignResponse(data.resultCode));
    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.log(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* specialGameListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoCampaignListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.status = payload.status;
    requestData.includePendingCampaigns = payload.includePendingCampaigns;
    requestData.searchString = payload.searchString || "";
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignSpecialGameListPost({ campaignControllerDtoCampaignListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoCampaignListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}
function* specialGameDetailRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    yield put(setSpecialGameDetail(null));

    const requestData = new CampaignControllerDtoCampaignDetailRequest();
    requestData.campaignNo =  payload.campaignNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignSpecialGameDetailPost({ campaignControllerDtoCampaignDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, CampaignControllerDtoCampaignDetailResponse);

    if (data.resultCode === 200) {
      yield put(setSpecialGameDetail(data));
    }

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}
function* specialGameRemoveRequestSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoCampaignRemoveRequest(payload.campaignNoArr);
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayCampaignSpecialGameRemovePost({ campaignControllerDtoCampaignRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);

    if (data.resultCode !== 200) {
      throw Error(`Error: ${data.resultCode}`);
    }
    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* specialGameCreateRequestSaga(payload) {
  try {
    console.log(payload, 'payload');
    const result = yield api.apiPerplayCampaignSpecialGameCreatePost(
      payload && payload.campaignTitle,
      payload && payload.startAt,
      payload && payload.endAt,
      payload && payload.appNo,
      payload && payload.campaignDesc,
      payload && payload.region,
      payload.needType === 1 || payload.needType === 10 ? payload.needMinNftGrade : 0,
      payload.needType === 1 || payload.needType === 10 ? payload.needMinNftLevel : 0,
      payload.needType === 1 || payload.needType === 10 ? payload.needNftType : 0,
      payload && payload.needType,
      payload && payload,
      () => {},
    );

    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw Error(`ERROR: ${data.resultCode}`);
    }

    payload.callback(data);
  } catch (e) {
    // api 호출 시 에러가 발생하면 이리로 온다.
    console.error(e);
    // if (payload.error) {
      payload.error(e);
    // }
  }
}

function* specialGameLockStateUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    yield put(setCampaignResponse(null));
    const requestData = new CampaignControllerDtoCampaignLockStateRequest(
      payload.campaignNo,
      payload.isLock,
    );
    console.log('요청 데이터: ', requestData);
    const result = yield api.apiPerplayCampaignSpecialGameLockStatePost(
      { campaignControllerDtoCampaignLockStateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw Error(`Error: ${data.resultCode}`);
    }

    yield put(setCampaignResponse(data.resultCode));
    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* specialGameTerminateRequestSaga(payload) {
  try {
    yield put(setCampaignResponse(null));
    const requestData = new CampaignControllerDtoCampaignTerminateRequest(
      payload.campaignNo,
    );
    const result = yield api.apiPerplayCampaignSpecialGameTerminatePost(
      { campaignControllerDtoCampaignTerminateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log(data);

    if (data.resultCode !== 200) {
      throw Error(`Error: ${data.resultCode}`);
    }
    yield put(setCampaignResponse(data.resultCode));
    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* campaignSortUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoCampaignSortRequest(
      payload.list,
    );
    let result;
    if (payload.gameCategory === 1) {
      result = yield api.apiPerplayCampaignRecommendedGameSortPost(
        { campaignControllerDtoCampaignSortRequest: requestData },
        () => {},
      );
    } else {
      result = yield api.apiPerplayCampaignSpecialGameSortPost(
        { campaignControllerDtoCampaignSortRequest: requestData },
        () => {},
      );
    }
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log(data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* campaignCheckPackageNameSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new CampaignControllerDtoAppSearchRequest();
    requestData.packageName = payload.packageName;

    const res = yield api.apiPerplayCampaignAppSearchPost(
      { campaignControllerDtoAppSearchRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      res,
      CampaignControllerDtoAppSearchResponse,
    );

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }
    // 캠페인 앱을 못 찾은 경우에도 200으로 온다.
    if (data.list.length === 0) {
      console.log(data);
      throw Error(`Error: app list is empty`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

// function* specialGameDepositRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData = new CampaignControllerDtoSpecialGameDepositRequest();
//     requestData.campaignNo = payload.campaignNo;
//     requestData.transactionHash = payload.transactionHash;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayCampaignSpecialGameDepositPost({ campaignControllerDtoSpecialGameDepositRequest: requestData }, () => {});
//     const data = api.apiClient.deserialize(result, BaseResponse);
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

function* specialGameUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    // const requestData = new CampaignControllerDtoCampaignUpdateRequest();
    // requestData.campaignNo = payload.campaignNo;
    // requestData.endAt = payload.endAt;
    // requestData.enableStartAt = payload.enableStartAt;
    // requestData.enableEndAt = payload.enableEndAt;
    // console.log('요청 데이터: ', requestData);
    //
    // const result = yield api.apiPerplayCampaignSpecialGameUpdatePost({ campaignControllerDtoCampaignUpdateRequest: requestData }, () => {});

    const result = yield api.apiPerplayCampaignSpecialGameUpdatePost(
        payload && payload.campaignNo,
        payload && payload.campaignTitle,
        payload && payload.startAt,
        payload && payload.endAt,
        payload && payload.appNo,
        payload && payload.campaignDesc,
        payload && payload.region,
        payload.needType === 1 || payload.needType === 10 ? payload.needMinNftGrade : 0,
        payload.needType === 1 || payload.needType === 10 ? payload.needMinNftLevel : 0,
        payload.needType === 1 || payload.needType === 10 ? payload.needNftType : 0,
        payload && payload.needType,
        payload && payload,
        () => {},
    )
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* recommendedGameUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    // const requestData = new CampaignControllerDtoCampaignUpdateRequest();
    // requestData.campaignNo = payload.campaignNo;
    // requestData.endAt = payload.endAt;
    // requestData.enableStartAt = payload.enableStartAt;
    // requestData.enableEndAt = payload.enableEndAt;
    // console.log('요청 데이터: ', requestData);
    // const result = yield api.apiPerplayCampaignRecommendedGameUpdatePost({ campaignControllerDtoCampaignUpdateRequest: requestData }, () => {})

    console.log('요청 데이터: ', { payload });
    const result = yield api.apiPerplayCampaignRecommendedGameUpdatePost(
        payload && payload.campaignNo,
        payload && payload.campaignTitle,
        payload && payload.startAt,
        payload && payload.endAt,
        payload && payload.appNo,
        payload && payload.campaignDesc,
        payload && payload.region,
        payload.needType === 1 || payload.needType === 10 ? payload.needMinNftGrade : 0,
        payload.needType === 1 || payload.needType === 10 ? payload.needMinNftLevel : 0,
        payload.needType === 1 || payload.needType === 10 ? payload.needNftType : 0,
        payload && payload.needType,
        payload && payload,
        () => {},
    )

    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* campaignRootSaga() {
  yield all([
    takeEvery(RECOMMENDED_GAME_LIST_REQUEST, recommendedGameListRequestSaga),
    takeEvery(RECOMMENDED_GAME_DETAIL_REQUEST,recommendedGameDetailRequestSaga),
    takeEvery(RECOMMENDED_GAME_REMOVE, recommendedGameRemoveRequestSaga),
    takeEvery(RECOMMENDED_GAME_CREATE, recommendedGameCreateRequestSaga),
    takeEvery(RECOMMENDED_GAME_LOCK_STATE_UPDATE, recommendedGameLockStateUpdateRequestSaga),
    takeEvery(RECOMMENDED_GAME_TERMINATE, recommendedGameTerminateRequestSaga),
    takeEvery(SPECIAL_GAME_LIST_REQUEST, specialGameListRequestSaga),
    takeEvery(SPECIAL_GAME_DETAIL_REQUEST, specialGameDetailRequestSaga),
    takeEvery(SPECIAL_GAME_REMOVE, specialGameRemoveRequestSaga),
    takeEvery(SPECIAL_GAME_CREATE, specialGameCreateRequestSaga),
    takeEvery(SPECIAL_GAME_LOCK_STATE_UPDATE, specialGameLockStateUpdateRequestSaga),
    takeEvery(SPECIAL_GAME_TERMINATE, specialGameTerminateRequestSaga),
    takeEvery(CAMPAIGN_SORT_UPDATE, campaignSortUpdateRequestSaga),
    takeEvery(CAMPAIGN_CHECK_PACKAGENAME, campaignCheckPackageNameSaga),
    // takeEvery(SPECIAL_GAME_DEPOSIT_REQUEST, specialGameDepositRequestSaga),
    takeEvery(SPECIAL_GAME_UPDATE_REQUEST, specialGameUpdateRequestSaga),
    takeEvery(RECOMMENDED_GAME_UPDATE_REQUEST, recommendedGameUpdateRequestSaga),
  ]);
}

const campaignSagas = [fork(campaignRootSaga)];
export default campaignSagas;
